<template>
  <div class="relative">
    <!-- Title  -->
    <vs-row v-if="!!title || (controls && !boardReadonly) || $slots.customTitle" class="flex items-center">
      <slot name="customTitle">
        <div v-if="!!title && titleType === 'small'" class="mb-4" style="font-weight: 700; font-size: 14px">{{ title }}</div>
        <h5 v-else-if="!!title" class="flex items-center mb-4"><i class="dot"></i>{{ title }}</h5>
      </slot>
      <!-- <template #buttons> 를 사용하지 않으면, 항목추기 / 항목삭제 가 사용된다. -->
      <div v-if="controls && !boardReadonly && !isPrint" class="ml-auto mb-4">
        <slot name="buttons" :handleAddButton="handleAddRow" :handleRemoveButton="handleRemoveRow" :checkData="checkData">
          <vs-button color="secondary" :type="controlTypeBorder ? 'border' : 'filled'" class="ml-4" @click="handleAddRow"> {{ buttonAddName }} </vs-button>
          <vs-button color="secondary" :type="!controlTypeBorder ? 'border' : 'filled'" :disabled="list.length < 1 || checkData.length === 0" class="ml-4" @click="handleRemoveRow"> {{ buttonRemoveName }} </vs-button>
        </slot>
      </div>
    </vs-row>
    <slot v-else name="customTitle" />

    <!-- Print Vertical (카드형) -->
    <div v-if="isPrint && printVertical" class="table-custom-body">
      <table v-for="(tr, indextr) in list" :key="indextr" class="print-vertical-card">
        <colgroup>
          <col class="print-vertical-card__label-col">
          <col>
        </colgroup>
        <tbody>
          <tr v-for="(cellData, indexTd) in tableData" :key="cellData.id">
            <th>{{ cellData.title }}</th>
            <td>
              <div v-if="cellData.type === 'no'">{{ indextr + 1 }}</div>
              <span v-else-if="cellData.type === 'dateArr'">{{ tr[cellData.id] && tr[cellData.id].sDate }} ~ {{ tr[cellData.id] && tr[cellData.id].eDate }}</span>
              <span v-else-if="cellData.type === 'timeArr'">{{ tr[cellData.id] && tr[cellData.id].sTime }} ~ {{ tr[cellData.id] && tr[cellData.id].eTime }}</span>
              <span v-else-if="cellData.type === 'period'">{{ tr[cellData.id] && tr[cellData.id].work_stime }} ~ {{ tr[cellData.id] && tr[cellData.id].work_etime }}</span>
              <div v-else-if="cellData.type === 'sign'" style="text-align: -webkit-center">
                <img v-if="tr[cellData.id]" :src="tr[cellData.id]" alt="Signature" class="signatureImg" />
                <div v-else style="width: 100%; height: 80px; min-width: 80px; max-width: 120px" class="print-input"></div>
              </div>
              <div v-else-if="cellData.type === 'file'" class="print-input">
                {{ tr[cellData.id] && tr[cellData.id].fileName ? tr[cellData.id].fileName : "" }}
              </div>
              <slot v-else-if="cellData.type === 'customType'" name="customType" :isMobile="isMobile" :index="indextr" :indexTd="indexTd" :trData="tr" :value="tr[cellData.id]" :id="cellData.id"></slot>
              <span v-else :class="cellData.type === 'textarea' ? 'print-textarea' : 'print-input'">{{ tr[cellData.id] }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Print -->
    <div v-else-if="isPrint" class="table-custom-body overflow-x-auto pb-2">
      <table :class="[thema === 'label' && 'label-table', borderX && 'border-x']">
        <colgroup>
          <col v-for="(col, col_i) in tableData" :key="`col_${col_i}_${col.id}`" :width="col.width" class="table-column" />
        </colgroup>
        <thead>
          <fragment v-if="!customThead">
            <tr ref="doubleHead">
              <slot name="doubleHead"></slot>
            </tr>
            <tr>
              <th v-for="th in tableData" :key="`${th.title}_${th.id}`" class="table-cell">
                <div class="w-full text-center">{{ th.title }}</div>
              </th>
            </tr>
          </fragment>
          <slot
            v-else
            name="customHead"
            :tableData="tableData"
            :isMobile="isMobile"
            :mobile="mobile"
            :multiple="multiple"
            :isPrint="true"
            :readonly="boardReadonly"
            :allCheckValue="checkData.length === list.length && 0 < list.length"
            :onClickAllCheck="onClickAllCheckbox"
          ></slot>
        </thead>
        <tbody v-for="(tr, indextr) in list" :key="indextr">
          <tr :style="{ 'z-index': list.length - indextr }" style="box-shadow: none !important; transform: translateY(0px)" class="print-container relative">
            <td
              v-for="(cellData, indexTd) in tableData"
              :key="`${indextr}_${indexTd}_${cellData.id}`"
              class="table-cell text-center"
              :class="cellData.className ? cellData.className : cellData.type === 'no' || cellData.type === 'label' || cellData.type === 'string' ? 'align-center' : 'align-top'"
              :style="cellData.style ? cellData.style : cellData.backgroundColor ? { backgroundColor: cellData.backgroundColor } : {}"
            >
              <div v-if="cellData.type === 'no'" :style="{ textAlign: cellData.align }">
                {{ indextr + 1 }}
              </div>
              <div v-else-if="cellData.type === 'label'" :style="{ textAlign: cellData.align }">
                {{ tr[cellData.id] }}
              </div>
              <div v-else @click.stop :class="cellData.afterText && 'afterTextContainer'">
                <div>
                  <span v-if="cellData.type === 'dateArr'"> {{ tr[cellData.id].sDate }} ~ {{ tr[cellData.id].eDate }} </span>
                  <span v-else-if="cellData.type === 'timeArr'"> {{ tr[cellData.id].sTime }} ~ {{ tr[cellData.id].eTime }} </span>
                  <span v-if="cellData.type === 'period'" class="print-input"> {{ tr[cellData.id].work_stime }} ~ {{ tr[cellData.id].work_etime }}</span>
                  <div v-else-if="cellData.type === 'sign'" style="text-align: -webkit-center">
                    <img v-if="tr[cellData.id]" :src="tr[cellData.id]" alt="Signature" class="signatureImg" />
                    <div v-else style="width: 100%; height: 80px; min-width: 80px; max-width: 120px" class="print-input"></div>
                  </div>
                  <div v-else-if="cellData.type === 'file'" class="print-input">
                    {{ tr[cellData.id] && tr[cellData.id].fileName ? tr[cellData.id].fileName : "" }}
                  </div>
                  <slot v-else-if="cellData.type === 'customType'" name="customType" :isMobile="isMobile" :index="indextr" :indexTd="indexTd" :trData="tr" :value="tr[cellData.id]" :id="cellData.id"></slot>
                  <div v-else class="print-input">{{ tr[cellData.id] }}</div>
                </div>

                <!-- AfterText(PRINT) : input 뒤에 글자를 붙이는 태그 -->
                <!-- 733번 Board | ex) 100"건" -->
                <p v-if="cellData.afterText" class="afterText">{{ cellData.afterText }}</p>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody>
          <slot name="customTr"></slot>
        </tbody>
      </table>
    </div>

    <!-- Table -->
    <div v-else class="table-custom-body overflow-x-auto pb-2">
      <table :class="[thema === 'label' && 'label-table', borderX && 'border-x']">
        <!-- colgroup -->
        <colgroup>
          <slot name="colgroup" :mobile="mobile" :isMobile="isMobile">
            <col v-if="useRowGroup && !boardReadonly && controls" width="40" />
            <col v-if="multiple && !isPrint && controls" width="40" />
            <col v-for="(col, col_i) in tableData" :key="`col_${col_i}_${col.id}`" :width=" (isMobile && !!col.mobileWidth && col.mobileWidth ) || (!!col.width && col.width)" class="xl:table-column" :class="[mobile.includes(col.id) ? 'table-column' : 'hidden']" />
            <col width="40" class="xl:hidden" />
          </slot>
        </colgroup>

        <!-- thead -->
        <thead>
          <fragment v-if="!customThead">
            <tr ref="doubleHead">
              <slot name="doubleHead"></slot>
            </tr>
            <tr>
              <th v-if="useRowGroup && !boardReadonly && controls">-</th>
              <th v-if="multiple && !isPrint && controls">
                <vs-checkbox :value="checkData.length === list.length && 0 < list.length" class="custom-checkbox justify-center mx-0" @click.native="onClickAllCheckbox" />
              </th>
              <th v-for="th in tableData" :key="`${th.title}_${th.id}`" class="xl:table-cell" :class="[mobile.includes(th.id) ? 'table-cell' : 'hidden']">
                <div class="w-full flex justify-center items-center">
                  <div class="text-center">{{ th.title }}</div>
                  <div v-if="th.info" class="info" style="color: #7e72f2; margin: 4px 0 0 4px">
                    <feather-icon icon="InfoIcon" svgClasses="h-5 w-5" class="info-icon" />
                    <div v-html="th.info"></div>
                  </div>
                </div>
              </th>
              <th class="xl:hidden"></th>
            </tr>
          </fragment>
          <slot
            v-else
            name="customHead"
            :tableData="tableData"
            :mobile="mobile"
            :isMobile="isMobile"
            :multiple="multiple"
            :isPrint="isPrint"
            :readonly="boardReadonly"
            :allCheckValue="checkData.length === list.length && 0 < list.length"
            :onClickAllCheck="onClickAllCheckbox"
          ></slot>
        </thead>

        <!-- tbody -->
        <tbody>
          <template v-for="(tr, indextr) in list">
            <tr :key="`tr1_${tr.id}_${indextr}`" class="tbody-tr">
              <td v-if="useRowGroup && !boardReadonly && controls && (findIndexOfGroup(tr.group) === -1 || findIndexOfGroup(tr.group) === indextr)" :rowspan="getGroupLength(tr.group) + 1" style="padding: 4px">
                <!-- 순서 변경 -->
                <div v-if="tr.group" class="grid gap-1">
                  <vx-tooltip html="맨 앞으로">
                    <div class="btn" :class="{ disabled: findIndexOfGroup(tr.group) === 0 }" style="width: 32px; height: 32px" @click="onChangeOrderByGroup(tr.group, 'first')">
                      <feather-icon icon="ChevronsUpIcon" />
                    </div>
                  </vx-tooltip>
                  <vx-tooltip html="한 칸 위로">
                    <div class="btn" :class="{ disabled: findIndexOfGroup(tr.group) === 0 }" style="width: 32px; height: 32px" @click="onChangeOrderByGroup(tr.group, 'prev')">
                      <feather-icon icon="ChevronUpIcon" />
                    </div>
                  </vx-tooltip>
                  <div class="my-1" style="border-top: 1px solid #cdcdcd" />
                  <vx-tooltip html="한 칸 아래로">
                    <div class="btn" :class="{ disabled: findLastIndexOfGroup(tr.group) === list.length - 1 }" style="width: 32px; height: 32px" @click="onChangeOrderByGroup(tr.group, 'next')">
                      <feather-icon icon="ChevronDownIcon" />
                    </div>
                  </vx-tooltip>
                  <vx-tooltip html="맨 뒤로">
                    <div class="btn" :class="{ disabled: findLastIndexOfGroup(tr.group) === list.length - 1 }" style="width: 32px; height: 32px" @click="onChangeOrderByGroup(tr.group, 'last')">
                      <feather-icon icon="ChevronsDownIcon" />
                    </div>
                  </vx-tooltip>
                </div>
              </td>
              <td v-if="multiple && !isPrint && controls">
                <div class="flex items-center">
                  <vs-checkbox v-if="!readonlyRowIds.includes(tr.id)" v-model="checkData" :vs-value="tr.id" class="custom-checkbox justify-center mx-0" />

                  <div v-if="draggable" class="ml-4 order-by">
                    <div class="btn" :class="{ disabled: indextr === 0 }" style="width: 32px; height: 32px" @click="onChangeOrderBy(tr, indextr, 'first')">
                      <feather-icon icon="ChevronsUpIcon" />
                    </div>
                    <div class="btn" :class="{ disabled: indextr === 0 }" style="width: 32px; height: 32px" @click="onChangeOrderBy(tr, indextr, 'prev')">
                      <feather-icon icon="ChevronUpIcon" />
                    </div>
                    <div class="my-1" style="border-top: 1px solid #cdcdcd" />
                    <div class="btn" :class="{ disabled: indextr === list.length - 1 }" style="width: 32px; height: 32px" @click="onChangeOrderBy(tr, indextr, 'next')">
                      <feather-icon icon="ChevronDownIcon" />
                    </div>
                    <div class="btn" :class="{ disabled: indextr === list.length - 1 }" style="width: 32px; height: 32px" @click="onChangeOrderBy(tr, indextr, 'last')">
                      <feather-icon icon="ChevronsDownIcon" />
                    </div>
                  </div>
                </div>
              </td>
              <td
                v-for="(cellData, indexTd) in tableData"
                :key="`${indextr}_${indexTd}_${cellData.id}`"
                :title="cellData.title"
                class="hidden xl:table-cell text-center"
                :class="cellData.className ? cellData.className : cellData.type === 'no' || cellData.type === 'label' || cellData.type === 'string' ? 'align-center' : 'align-top'"
                :style="cellData.style ? cellData.style : cellData.backgroundColor ? { backgroundColor: cellData.backgroundColor } : {}"
                :rowspan="useRowGroup && rowGroup.indexOf(cellData.id) > -1 ? getGroupLength(tr.group) : 1"
                v-if="!useRowGroup || findIndexOfGroup(tr.group) === -1 || findIndexOfGroup(tr.group) === indextr || rowGroup.indexOf(cellData.id) === -1"
              >
                <div v-if="cellData.type === 'no'" :style="{ textAlign: cellData.align }">
                  {{ indextr + 1 }}
                </div>
                <div v-else-if="cellData.type === 'label'" :style="{ textAlign: cellData.align }">
                  {{ tr[cellData.id] }}
                </div>
                <div v-else @click.stop :class="cellData.afterText && 'afterTextContainer'">
                  <!-- Print -->
                  <span v-if="isPrint && cellData.type === 'textarea'" class="print-textarea">
                    {{ tr[cellData.id] }}
                  </span>
                  <span v-if="isPrint && cellData.type === 'dateArr'"> {{ tr[cellData.id].sDate }} ~ {{ tr[cellData.id].eDate }} </span>
                  <span v-if="isPrint && cellData.type === 'timeArr'"> {{ tr[cellData.id].sTime }} ~ {{ tr[cellData.id].eTime }} </span>
                  <div v-else-if="isPrint">
                    <div v-if="cellData.type !== 'sign'" class="print-input">
                      {{ tr[cellData.id] }}
                    </div>
                    <div v-else style="text-align: -webkit-center">
                      <img v-if="tr[cellData.id]" :src="tr[cellData.id]" alt="Signature" class="signatureImg" />
                      <div v-else style="width: 100%; height: 80px; min-width: 80px; max-width: 120px" class="print-input"></div>
                    </div>
                  </div>
                  <!-- Content -->
                  <div v-else>
                    <div v-if="cellData.type === 'string'" :style="{ textAlign: cellData.align }" v-html="tr[cellData.id]"></div>
                    <ml-input
                      v-else-if="cellData.type === 'text'"
                      :readonly="getReadonly(cellData, indextr, tr)"
                      :visible-counter="!cellData.invisible"
                      :max="cellData.max || 20"
                      v-model="tr[cellData.id]"
                      :placeholder="cellData.placeholder"
                      class="w-full flex-1"
                      @click.stop
                      @focusout="(e) => (cellData.focusout ? cellData.focusout(e, indextr, cellData.id) : null)"
                      @input="
                        (data) => {
                          onInput(data, tr, cellData);
                        }
                      "
                    />
                    <ml-input v-else-if="cellData.type === 'valueText'" :readonly="getReadonly(cellData, indextr, tr)" visibleCounter :value="cellData.value" :placeholder="cellData.placeholder" class="w-full flex-1" @click.stop />
                    <LinkInput
                      v-else-if="cellData.type === 'link'"
                      :readonly="getReadonly(cellData, indextr, tr)"
                      v-model="tr[cellData.id]"
                      :placeholder="cellData.placeholder"
                      class="w-full flex-1"
                      @click.stop
                      @input="
                        (data) => {
                          onInput(data, tr, cellData);
                        }
                      "
                    />
                    <slot v-else-if="cellData.type === 'calcul'" name="calcul" v-bind:data="tr" v-bind:data_i="indextr"></slot>
                    <ml-input
                      v-else-if="cellData.type === 'fixed-text'"
                      :readonly="true"
                      visibleCounter
                      v-model="tr[cellData.id]"
                      :placeholder="cellData.placeholder"
                      class="w-full flex-1"
                      @click.stop
                      @input="
                        (data) => {
                          onInput(data, tr, cellData);
                        }
                      "
                    />
                    <number-input
                      v-else-if="cellData.type === 'number'"
                      :readonly="getReadonly(cellData, indextr, tr)"
                      :textAlign="cellData.textAlign"
                      v-model="tr[cellData.id]"
                      :placeholder="cellData.placeholder"
                      class="w-full flex-1"
                      @click.stop
                      @change="() => onChangeEvent(cellData.changeEvent, indextr, tr[cellData.id])"
                      @input="
                        (data) => {
                          onInput(data, tr, cellData);

                          if (cellData.inputFunction && typeof cellData.inputFunction === 'function') {
                            cellData.inputFunction(data, tr, cellData, indextr);
                          }
                        }
                      "
                      :decimal-places="cellData.decimalPlaces ? cellData.decimalPlaces : null"
                      :input-style="cellData.contentStyle ? cellData.contentStyle : {}"
                      :max="cellData.max"
                      :min="cellData.min"
                    />
                    <ml-textarea
                      v-if="cellData.type === 'textarea'"
                      :readonly="getReadonly(cellData, indextr, tr)"
                      v-model="tr[cellData.id]"
                      :placeholder="!!cellData.placeholder ? (typeof cellData.placeholder === 'string' ? cellData.placeholder : cellData.placeholder[indextr]) : ''"
                      class="w-full flex-1 mb-0"
                      :rows="cellData.rows ? cellData.rows : 3"
                      :style="cellData.contentStyle ? cellData.contentStyle : {}"
                      @click.stop
                      @blur="cellData.blurEvent ? blurEvent(tr) : null"
                      @input="
                        (data) => {
                          onInput(data, tr, cellData);
                        }
                      "
                    />
                    <ml-input
                      v-else-if="cellData.type === 'select' && boardReadonly"
                      visibleCounter
                      v-model="tr[cellData.id]"
                      readonly
                      class="w-full flex-1"
                      @input="
                        (data) => {
                          onInput(data, tr, cellData);
                        }
                      "
                    />
                    <vs-select
                      v-else-if="cellData.type === 'select'"
                      v-model="tr[cellData.id]"
                      :disabled="getReadonly(cellData, indextr, tr)"
                      :placeholder="cellData.placeholder"
                      class="w-full flex-1"
                      autocomplete
                      @input="
                        (data) => {
                          onInput(
                            data,
                            tr,
                            cellData,
                            cellData.changeEvent
                              ? () => {
                                  changeEvent(indextr, tr);
                                }
                              : null
                          );
                        }
                      "
                    >
                      <vs-select-item v-for="selectData in cellData.selectData" :key="selectData" :text="selectData" :value="selectData" />
                    </vs-select>
                    <date-selector
                      v-else-if="cellData.type === 'date'"
                      class="w-full"
                      v-model="tr[cellData.id]"
                      :readonly="getReadonly(cellData, indextr, tr)"
                      :min-date="cellData.minDate"
                      :max-date="cellData.maxDate"
                      @click.stop
                      @input="
                        (data) => {
                          onInput(data, tr, cellData);
                        }
                      "
                    />
                    <period-picker
                      v-else-if="cellData.type === 'period'"
                      v-model="tr[cellData.id]"
                      :readonly="getReadonly(cellData, indextr, tr)"
                      @input="
                        (data) => {
                          onInput(data, tr, cellData);
                        }
                      "
                    />
                    <CompanySelector
                      v-else-if="cellData.type === 'company'"
                      v-model="tr[cellData.id]"
                      :readonly="getReadonly(cellData, indextr, tr)"
                      @click.stop
                      @input="
                        (data) => {
                          onInput(data, tr, cellData);
                        }
                      "
                    />
                    <member-selector
                      v-else-if="cellData.type === 'member'"
                      v-model="tr[cellData.id].id"
                      :member-name="tr[cellData.id].name"
                      :readonly="getReadonly(cellData, indextr, tr)"
                      @click.stop
                      @select="(member) => (tr[cellData.id] = member)"
                      @input="
                        (data) => {
                          onInput(data, tr, cellData);
                        }
                      "
                    />
                    <field-selector
                      v-else-if="cellData.type === 'field'"
                      v-model="tr[cellData.id]"
                      :readonly="getReadonly(cellData, indextr, tr)"
                      @input="
                        (data) => {
                          onInput(data, tr, cellData);
                        }
                      "
                    />
                    <date-selector-rang
                      v-else-if="cellData.type === 'dateArr'"
                      v-model="tr[cellData.id]"
                      :readonly="getReadonly(cellData, indextr, tr)"
                      class="flex items-center gap-2"
                      @input="
                        (data) => {
                          onInput(data, tr, cellData);
                        }
                      "
                    />
                    <sign-field
                      v-else-if="cellData.type === 'sign'"
                      v-model="tr[cellData.id]"
                      :readonly="getReadonly(cellData, indextr, tr)"
                      @input="
                        (data) => {
                          onInput(data, tr, cellData);
                        }
                      "
                    />
                    <FileUploader
                      v-else-if="cellData.type === 'file'"
                      v-model="tr[cellData.id]"
                      :readonly="getReadonly(cellData, indextr, tr)"
                      @input="
                        (data) => {
                          onInput(data, tr, cellData);
                        }
                      "
                    />
                    <FileUploaderTransparent
                      v-else-if="cellData.type === 'img'"
                      v-model="tr[cellData.id]"
                      :readonly="getReadonly(cellData, indextr, tr)"
                      style="height: 200px !important; border: 1px dashed #cdcdcd; border-radius: 6px"
                      :style="cellData.style"
                      @input="
                        (data) => {
                          onInput(data, tr, cellData);
                        }
                      "
                    />
                    <div v-else-if="cellData.type === 'radio'" class="p-3 flex justify-center items-center gap-3">
                      <vs-radio
                        v-for="(radioItem, radioItem_i) in cellData.radioItems"
                        :key="`${indextr}_${radioItem_i}`"
                        v-model="tr[cellData.id]"
                        :vs-name="`${cellData.id}_${indextr}_${indexTd}_${radioItem_i}`"
                        :vs-value="radioItem.value"
                        :disabled="getReadonly(cellData, indextr, tr)"
                        @input="
                          (data) => {
                            onInput(data, tr, cellData);
                          }
                        "
                      >
                        {{ radioItem.label || radioItem.value }}
                      </vs-radio>
                    </div>
                    <div v-else-if="cellData.type === 'time'" class="flex flex-row items-center gap-1">
                      <time-selector
                        v-model="tr[cellData.id]"
                        :readonly="getReadonly(cellData, indextr, tr)"
                        class="w-full"
                        @input="
                          (data) => {
                            onInput(data, tr, cellData);
                          }
                        "
                      />
                    </div>
                    <div v-else-if="cellData.type === 'timeArr'" class="flex flex-row items-center gap-1">
                      <time-selector
                        v-model="tr[cellData.id].sTime"
                        :readonly="getReadonly(cellData, indextr, tr)"
                        @input="
                          (data) => {
                            onInput(data, tr, cellData);
                          }
                        "
                      />
                      <p>~</p>
                      <time-selector
                        v-model="tr[cellData.id].eTime"
                        :readonly="getReadonly(cellData, indextr, tr)"
                        @input="
                          (data) => {
                            onInput(data, tr, cellData);
                          }
                        "
                      />
                    </div>
                    <disaster-class-selector
                      v-else-if="cellData.type === 'disaster'"
                      class="w-full"
                      :readonly="getReadonly(cellData, indextr, tr)"
                      v-model="tr[cellData.id]"
                      @input="
                        (data) => {
                          onInput(data, tr, cellData);
                        }
                      "
                    />
                    <div v-else-if="cellData.type === 'customType'">
                      <slot
                        name="customType"
                        :isMobile="isMobile"
                        :index="indextr"
                        :indexTd="indexTd"
                        :trData="tr"
                        :value="tr[cellData.id]"
                        :id="cellData.id"
                        :input="(data) => customTypeInput(indextr, cellData.id, data)"
                        :readonly="getReadonly(cellData, indextr, tr)"
                      ></slot>
                    </div>
                  </div>

                  <!-- AfterText(CONTENT) : input 뒤에 글자를 붙이는 태그 -->
                  <!-- 733번 Board | ex) 100"건" -->
                  <p v-if="cellData.afterText" class="afterText">{{ cellData.afterText }}</p>
                </div>
                <!-- 에러메시지를 표기한다. -->
                <div v-if="errorMsg[indextr] && errorMsg[indextr][cellData.id]" class="errorMsg" :class="['text', 'textarea'].includes(cellData.type) && 'err-counter'">
                  <img src="@/assets/images/icon/icon-circle-alert-red.svg" alt="circle" style="padding: 1px 0" class="mr-1" />
                  <p>{{ errorMsg[indextr][cellData.id] }}</p>
                </div>
              </td>
              <!-- Mobile -->
              <td class="xl:hidden text-base text-center py-4" v-for="(mobileData, mobileData_i) in mobile" :key="`${mobileData}_${mobileData_i}`">
                <slot name="mobileTableColumns" :mobileData="mobileData" :trData="tr" :value="tr[mobileData]">{{ tr[mobileData] }}</slot>
                <!--              <div v-if="tableData.find((data)=>data.id === mobileData).type === 'customType'">-->

                <!--              </div>-->
                <!--              <div>-->
                <!--                -->
                <!--              </div>-->
              </td>
              <td class="xl:hidden" @click="openMobile(indextr)">
                <img src="@/assets/icons/triangle_down.svg" class="mx-auto duration-200" :style="{ transform: tr.open ? 'rotate(180deg)' : 'rotate(0deg)' }" />
              </td>
            </tr>

            <!-- addGroup -->
            <tr v-if="useRowGroup && !boardReadonly && controls && (!tr.group || lastIndexOfGroup(tr.group) === indextr)" :key="`addGroup_${tr.id}_${indextr}`">
              <td :colspan="tableData.length + 1" class="p-0">
                <button class="addGroupButton w-full py-1 px-2" :class="{ disabled: boardReadonly }" @click="onClickAddRowGroup(tr)">+ 추가</button>
              </td>
            </tr>

            <!-- MobileTab -->
            <tr v-show="tr.open" class="xl:hidden">
              <td :colspan="mobile.length + (multiple && !isPrint && controls ? 2 : 1)" class="py-4 px-3">
                <div class="writeGridContainer mb-0">
                  <div v-for="(cellData, cellIdx) in tableData" :key="`${cellIdx}_${cellData.id}`" v-show="cellData.type !== 'no' && cellData.type !== 'label'">
                    <div v-html="cellData.title"></div>
                    <ml-input
                      v-if="cellData.type === 'text'"
                      :readonly="getReadonly(cellData, indextr, tr)"
                      :visible-counter="!cellData.invisible"
                      :max="cellData.max || 20"
                      v-model="tr[cellData.id]"
                      :placeholder="cellData.placeholder"
                      class="w-full flex-1"
                      @click.stop
                      @focusout="(e) => (cellData.focusout ? cellData.focusout(e, indextr, cellData.id) : null)"
                    />
                    <ml-input v-else-if="cellData.type === 'valueText'" :readonly="getReadonly(cellData, indextr, tr)" visibleCounter :value="cellData.value" :placeholder="cellData.placeholder" class="w-full flex-1" @click.stop />
                    <LinkInput v-else-if="cellData.type === 'link'" :readonly="getReadonly(cellData, indextr, tr)" v-model="tr[cellData.id]" :placeholder="cellData.placeholder" class="w-full flex-1" @click.stop />
                    <ml-input v-else-if="cellData.type === 'fixed-text'" :readonly="true" v-model="tr[cellData.id]" visibleCounter :placeholder="cellData.placeholder" class="w-full flex-1" @click.stop />
                    <number-input
                      v-else-if="cellData.type === 'number'"
                      :readonly="getReadonly(cellData, indextr, tr)"
                      :textAlign="cellData.textAlign"
                      v-model="tr[cellData.id]"
                      :placeholder="cellData.placeholder"
                      class="w-full flex-1"
                      @click.stop
                      @change="() => onChangeEvent(cellData.changeEvent, indextr, tr[cellData.id])"
                      :decimal-places="cellData.decimalPlaces ? cellData.decimalPlaces : null"
                      :input-Style="cellData.contentStyle ? cellData.contentStyle : {}"
                      @input="
                        (data) => {
                          onInput(data, tr, cellData);

                          if (cellData.inputFunction && typeof cellData.inputFunction === 'function') {
                            cellData.inputFunction(data, tr, cellData, indextr);
                          }
                        }
                      "
                      :max="cellData.max"
                      :min="cellData.min"
                    />
                    <ml-textarea
                      v-else-if="cellData.type === 'textarea'"
                      height="90px"
                      :readonly="getReadonly(cellData, indextr, tr)"
                      v-model="tr[cellData.id]"
                      :placeholder="cellData.placeholder"
                      class="w-full flex-1 mb-0"
                      @click.stop
                      @blur="cellData.blurEvent ? blurEvent(tr) : null"
                    />
                    <FileUploaderTransparent
                      v-else-if="cellData.type === 'img'"
                      v-model="tr[cellData.id]"
                      :readonly="getReadonly(cellData, indextr, tr)"
                      style="height: 200px !important; border: 1px dashed #cdcdcd; border-radius: 6px"
                      :style="cellData.style"
                      @input="
                        (data) => {
                          onInput(data, tr, cellData);
                        }
                      "
                    />
                    <!-- 읽기전용 select 를 텍스트로 표시한다.
                         readonlyIndexList 조건에 타입 검사를 빼면 img 등 객체형 셀까지 이 입력창에 물려서 값이 훼손된다. -->
                    <ml-input
                      v-else-if="cellData.type === 'select' && (boardReadonly || (cellData.readonlyIndexList && cellData.readonlyIndexList.includes(indextr)))"
                      visibleCounter
                      v-model="tr[cellData.id]"
                      readonly
                      class="w-full flex-1"
                    />
                    <vs-select
                      v-else-if="cellData.type === 'select'"
                      v-model="tr[cellData.id]"
                      :placeholder="cellData.placeholder"
                      class="w-full flex-1"
                      autocomplete
                      @input="cellData.changeEvent ? changeEvent(indextr, tr) : null"
                      :disabled="getReadonly(cellData, indextr, tr)"
                    >
                      <vs-select-item v-for="selectData in cellData.selectData" :key="selectData" :text="selectData" :value="selectData" />
                    </vs-select>
                    <date-selector v-else-if="cellData.type === 'date'" class="w-full" v-model="tr[cellData.id]" :readonly="getReadonly(cellData, indextr, tr)" :min-date="cellData.minDate" :max-date="cellData.maxDate" @click.stop />
                    <period-picker v-else-if="cellData.type === 'period'" v-model="tr[cellData.id]" :readonly="getReadonly(cellData, indextr, tr)" />
                    <CompanySelector v-else-if="cellData.type === 'company'" v-model="tr[cellData.id]" :readonly="getReadonly(cellData, indextr, tr)" @click.stop />
                    <member-selector v-else-if="cellData.type === 'member'" v-model="tr[cellData.id].id" :member-name="tr[cellData.id].name" :readonly="getReadonly(cellData, indextr, tr)" @click.stop />
                    <field-selector v-else-if="cellData.type === 'field'" v-model="tr[cellData.id]" :readonly="getReadonly(cellData, indextr, tr)" />
                    <date-selector-rang v-else-if="cellData.type === 'dateArr'" v-model="tr[cellData.id]" :readonly="getReadonly(cellData, indextr, tr)" class="flex items-center gap-2" />
                    <sign-field v-else-if="cellData.type === 'sign'" v-model="tr[cellData.id]" :readonly="getReadonly(cellData, indextr, tr)" />
                    <FileUploader v-else-if="cellData.type === 'file'" v-model="tr[cellData.id]" :readonly="getReadonly(cellData, indextr, tr)" />
                    <div v-else-if="cellData.type === 'time'">
                      <time-selector v-model="tr[cellData.id]" :readonly="getReadonly(cellData, indextr, tr)" class="w-full" />
                    </div>
                    <div v-else-if="cellData.type === 'timeArr'">
                      <time-selector v-model="tr[cellData.id].sTime" :readonly="getReadonly(cellData, indextr, tr)" />
                      <p>~</p>
                      <time-selector v-model="tr[cellData.id].eTime" :readonly="getReadonly(cellData, indextr, tr)" />
                    </div>
                    <disaster-class-selector v-else-if="cellData.type === 'disaster'" class="w-full" :readonly="getReadonly(cellData, indextr, tr)" v-model="tr[cellData.id]" />
                    <div v-else-if="cellData.type === 'customType'">
                      <slot name="customType" :isMobile="isMobile" :index="indextr" :indexTd="cellIdx" :trData="tr" :value="tr[cellData.id]" :id="cellData.id" :input="(data) => customTypeInput(indextr, cellData.id, data)"></slot>
                    </div>
                    <div v-else-if="cellData.type === 'radio'" class="flex flex-wrap items-center gap-3 py-3">
                      <vs-radio
                        v-for="(radioItem, radioItem_i) in cellData.radioItems"
                        :key="`${indextr}_${cellIdx}_${radioItem_i}`"
                        v-model="tr[cellData.id]"
                        :vs-name="`${cellData.id}_${indextr}_${cellIdx}`"
                        :vs-value="radioItem.value"
                        :disabled="getReadonly(cellData, indextr, tr)"
                      >
                        {{ radioItem.label || radioItem.value }}
                      </vs-radio>
                    </div>

                    <!-- AfterText(MOBILE) : input 뒤에 글자를 붙이는 태그 -->
                    <!-- 733번 Board | ex) 100"건" -->
                    <p v-if="cellData.afterText" class="afterText">{{ cellData.afterText }}</p>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
        <tbody>
          <slot name="customTr"></slot>
        </tbody>
      </table>
      <div v-if="useBottomAddButton" class="mt-2">
        <vs-button color="secondary" :type="controlTypeBorder ? 'border' : 'filled'" class="w-full py-1" @click="handleAddRow"> {{ buttonAddName }} </vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import DateSelectorRang from "@/components/selector/DateSelectorRang";
import DateSelector from "./selector/DateSelector";
import TimeSelector from "./selector/TimeSelector";
import NumberInput from "@/components/NumberInput.vue";
import PeriodPicker from "./PeriodPicker";
import CompanySelector from "@/components/selector/CompanySelector";
import SignField from "@/components/SignField";
import FieldSelector from "@/components/selector/FieldSelector";
import FileUploader from "@/components/FileUploader.vue";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector.vue";
import FileUploaderTransparent from "@/components/FileUploaderTransparent2";
import MemberSelector from "@/components/selector/MemberSelector.vue";

export default {
  name: "TableCustom",
  components: {
    MemberSelector,
    DisasterClassSelector,
    SignField,
    DateSelectorRang,
    PeriodPicker,
    NumberInput,
    TimeSelector,
    DateSelector,
    CompanySelector,
    FieldSelector,
    FileUploader,
    FileUploaderTransparent,
  },
  props: {
    isPrint: Boolean,
    printVertical: {
      type: Boolean,
      default: false,
    },
    board: Object,
    readonly: {
      type: Boolean,
      default: false,
    },
    controls: {
      type: Boolean,
      default: true,
    },
    borderX: {
      type: Boolean,
      default: true,
    },
    // 컨트롤 버튼(추가,제거) type(boarder)을 반전시키는 prop
    controlTypeBorder: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    customThead: {
      type: Boolean,
      default: false,
    },
    draggable: {
      type: Boolean,
      default: false,
    },
    useRowGroup: {
      type: Boolean,
      default: false,
    },
    rowGroup: {
      type: Array,
      default: () => [],
    },
    thema: {
      type: String,
      default: "default",
    },
    title: String,
    titleType: String,
    tableData: Array,
    value: {
      type: Array,
      default: () => [],
    },
    // Input아래에 에러메시지를 표시한다. 728
    // [{index1:'errorMsg'}]
    errorMsg: {
      type: Array,
      default: () => [],
    },
    minSize: {
      type: Number | String,
      default: 1,
    },
    maxSize: {
      type: Number | String,
      default: 0,
    },
    // 처음 실행시 추가할 행의 갯수
    defaultSize: {
      type: Number,
      default: 1,
    },
    mobile: {
      type: Array,
      default: () => [],
    },
    buttonAddName: {
      type: String,
      default: "항목추가",
    },
    buttonRemoveName: {
      type: String,
      default: "선택삭제",
    },
    // 직접 추가 버튼을 제어할 경우 TRUE
    customAddHandler: {
      type: Boolean,
      default: false,
    },
    customRemoveHandler: {
      type: Boolean,
      default: false,
    },
    useBottomAddButton: Boolean,
    readonlyRowIds: { type: Array, default: () => [] },
  },
  computed: {
    isMobile() {
      return this.$viewport.isMobile;
    },
    boardReadonly() {
      if (this.board) {
        return this.board.readonly;
      }
      return this.readonly;
    },
  },
  emits: ["input", "add-row", "remove-row"],
  data() {
    return {
      id: Math.random().toString(36).substr(2, 9),
      checkData: [],
      list: this.value,
      dateArrCheck: [],
      numberId: 0 < this.value.length ? this.value[this.value.length - 1].id : 0,
    };
  },
  watch: {
    value: {
      handler(value) {
        this.list = value;
        this.numberId = 0 < value.length ? value[value.length - 1].id : 0;
      },
    },
    list: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
        this.updateReadonlyIndexList();
      },
    },
  },
  created() {
    // 추가버튼때 데이터를 넣기위해 dateArr의 id 값을 찾는다.
    this.dateArrCheck = this.tableData.map((td) => {
      if (td.type === "dateArr") return td.id;
    });
  },
  methods: {
    // All 체크박스 클릭
    onClickAllCheckbox() {
      if (this.checkData.length === this.list.length) this.checkData = [];
      else this.checkData = this.list.map((item) => item.id);
    },
    // 항목추가
    handleAddRow(startIndex, group) {
      if (this.customAddHandler) {
        this.$emit("add-row");
        return;
      }

      const maxSize = parseInt(this.maxSize);
      if (maxSize > 0) {
        if (this.list.length >= maxSize) {
          alert(`${maxSize}개 이하로 입력이 가능합니다.`);
          return;
        }
      }

      this.numberId++;
      const randomId = Math.floor(Math.random() * 1000000) + new Date().getTime();
      const addData = { id: randomId };
      const findTypeTime = this.tableData.find((_td) => _td.type === "timeArr");
      if (findTypeTime) {
        addData[findTypeTime.id] = { sTime: "", eTime: "" };
      }
      const findMember = this.tableData.find((_td) => _td.type === "member");
      if (findMember) {
        addData[findMember.id] = { id: "", name: "" };
      }
      if (0 < this.dateArrCheck.length) {
        this.dateArrCheck.map((_adc) => {
          if (_adc) {
            addData[_adc] = {};
          }
        });
      }

      // default value 추가
      if (this.tableData.length > 0) {
        for (const td of this.tableData) {
          if (td.defaultValue) {
            addData[td.id] = td.defaultValue || "";
          }
        }
      }

      if (this.useRowGroup) {
        // group 추가
        addData.group = group || `group-${Math.floor(Math.random() * 10000)}-${new Date().getTime()}`;

        // rowGroup 에 포함된 데이터는 복사하여 전달한다.
        if (typeof startIndex === "number") {
          for (const key of this.rowGroup) {
            addData[key] = this.list[startIndex][key];
          }
        }
      }

      if (typeof startIndex === "number") {
        this.list.splice(startIndex + 1, 0, addData);
      } else {
        this.list.push(addData);
      }

      this.$emit("add", addData);
    },
    // 선택삭제
    handleRemoveRow() {
      if (this.customRemoveHandler) {
        this.$emit("remove-row", this.checkData);
        this.checkData = [];

        if (this.list.length < this.minSize) {
          this.handleAddRow();
        }

        return;
      }

      // 전체 삭제가 될 경우, 미리 새 행 추가
      const isAllDeleted = this.list.length === this.checkData.length;

      // 기존 데이터 삭제 (새로 추가된 데이터 제외)
      this.$nextTick(() => {
        this.list = this.list.filter((item) => !this.checkData.includes(item.id));

        if (isAllDeleted) {
          this.handleAddRow();
        }

        this.$emit("remove", this.list, this.checkData);
        this.checkData = [];
      });
    },

    getReadonly(cellData, indextr, inputData) {
      if (inputData && inputData.id) return this.boardReadonly || cellData.readonly || (cellData.readonlyIndexList && cellData.readonlyIndexList.includes(indextr)) || this.readonlyRowIds.includes(inputData.id);
      else return this.boardReadonly || cellData.readonly || (cellData.readonlyIndexList && cellData.readonlyIndexList.includes(indextr));
    },

    updateReadonlyIndexList() {
      this.tableData.forEach((td) => {
        if (!td.readonlyOtherTd) return;

        // 초기화
        if (!td.readonlyIndexList) td.readonlyIndexList = [];

        const cond = td.readonlyOtherTd;

        // readonlyOtherTd: { id: '계측가능여부', condition: '=', value: 'Y' } },
        // 계측가능여부가 N이면 readonlyOtherTd:계측가능여부
        // 변경된 row만 계산
        this.list.forEach((tr, index) => {
          const val = tr[cond.id];

          const isReadonly = (() => {
            switch (cond.condition) {
              case "=":
                return val === cond.value;
              case "!=":
                return val !== cond.value;
              case ">":
                return val > cond.value;
              case "<":
                return val < cond.value;
              default:
                return false;
            }
          })();

          const alreadyInList = td.readonlyIndexList.includes(index);

          if (isReadonly && !alreadyInList) {
            td.readonlyIndexList.push(index);
            this.$set(this.list[index], td.id, ""); // 값 제거
          } else if (!isReadonly && alreadyInList) {
            td.readonlyIndexList = td.readonlyIndexList.filter((i) => i !== index);
          }
        });
      });
    },

    openMobile(indextr) {
      const target = this.list[indextr];
      this.$set(target, "open", target.open ? !target.open : true);
    },

    customTypeInput(index, key, data) {
      this.$set(this.list[index], key, data);
    },

    changeEvent(index, data) {
      this.$emit("changeEvent", index, data);
    },

    // 내용이 변경되면 지정된 이름으로 emit
    onChangeEvent(eventName, index, data) {
      if (!eventName) return;
      this.$emit(eventName, index, data);
    },

    blurEvent(data) {
      this.$emit("blurEvent", data);
    },

    getGroupLength(group) {
      if (group) {
        return this.list.filter((item) => item.group === group).length;
      }

      return 1;
    },
    onClickAddRowGroup(row) {
      if (this.boardReadonly) {
        return;
      }

      const group = row.group || `group-${Math.floor(Math.random() * 10000)}-${new Date().getTime()}`;
      row.group = group;

      // 동일한 group 의 가장 마지막 index 찾기
      const lastIndex = this.lastIndexOfGroup(group);
      this.handleAddRow(lastIndex, group);
    },
    // 동일한 group 의 가장 마지막 index 찾기
    lastIndexOfGroup(group) {
      if (group) {
        return this.list.map((item) => item.group).lastIndexOf(group);
      }
      return -1;
    },

    // 동일한 group 의 가장 처음 index 찾기
    findIndexOfGroup(group) {
      if (group) {
        return this.list.map((item) => item.group).indexOf(group);
      } else {
        return -1;
      }
    },

    // 동일한 group 의 가장 마지막 index 찾기
    findLastIndexOfGroup(group) {
      if (group) {
        return this.list.map((item) => item.group).lastIndexOf(group);
      } else {
        return -1;
      }
    },

    onInput(value, trData, cellData, callback) {
      if (callback) {
        callback();
      }

      // group 모드를 사용했을 경우, 통합데이터 (rowGroup key 에 포함된 데이터)가 수정되면 해당 그룹에 포함된, 모든 row 의 데이터가 수정된다.
      if (this.useRowGroup && this.rowGroup && trData.group && this.rowGroup.indexOf(cellData.id) > -1) {
        const key = cellData.id;
        const group = trData.group;
        for (const row of this.list) {
          if (row.group === group) {
            this.$set(row, key, value);
          }
        }
      }
    },

    onChangeOrderBy(tr, index, orderBy) {
      const list = this.list;

      // 복사해서 안전하게 처리
      const item = list[index];

      // 현재 인덱스 기준으로 이동
      if (orderBy === "first" && index > 0) {
        list.splice(index, 1);
        list.unshift(item);
      } else if (orderBy === "prev" && index > 0) {
        list.splice(index, 1);
        list.splice(index - 1, 0, item);
      } else if (orderBy === "next" && index < list.length - 1) {
        list.splice(index, 1);
        list.splice(index + 1, 0, item);
      } else if (orderBy === "last" && index < list.length - 1) {
        list.splice(index, 1);
        list.push(item);
      }

      // 강제로 반응성 동작 (Vue2에서 필요한 경우)
      this.list = [...list];
    },

    onChangeOrderByGroup(group, orderBy) {
      // 현재 그룹의 시작 인덱스와 길이를 구합니다
      const currentIndex = this.findIndexOfGroup(group);
      const groupLength = this.getGroupLength(group);

      if (currentIndex === -1) return;

      // 현재 그룹의 데이터를 임시 저장
      const groupData = this.list.splice(currentIndex, groupLength);

      let targetIndex;
      if (orderBy === "first") {
        // 맨 앞으로 이동
        targetIndex = 0;
      } else if (orderBy === "prev") {
        // 이전 그룹의 시작 위치 찾기
        if (currentIndex > 0) {
          const prevGroup = this.list[currentIndex - 1].group;
          const prevGroupIndex = this.findIndexOfGroup(prevGroup);
          targetIndex = prevGroupIndex;
        } else {
          // 이전 그룹이 없을 경우, 맨 앞으로 이동
          targetIndex = 0;
        }
      } else if (orderBy === "next") {
        // 다음 그룹의 시작 위치 찾기
        if (this.list.length > currentIndex) {
          const nextGroup = this.list[currentIndex].group;
          const nextGroupLastIndex = this.findLastIndexOfGroup(nextGroup);
          targetIndex = nextGroupLastIndex + 1;
        } else {
          // 다음 그룹이 없을 경우, 맨 뒤로 이동
          targetIndex = this.list.length;
        }
      } else if (orderBy === "last") {
        // 맨 뒤로 이동
        targetIndex = this.list.length;
      }

      // 그룹 데이터를 새로운 위치에 삽입
      this.list.splice(targetIndex, 0, ...groupData);
    },
  },
  mounted() {
    // 컴포넌트가 처음 실행될 때, 무조건 1개 이상의 행을 추가한다.
    const addSize = this.defaultSize || this.minSize;
    if (!this.isPrint && this.list.length < this.minSize) {
      if (!this.customAddHandler) {
        for (let i = 0; i < addSize; i++) {
          this.handleAddRow();
        }
      }
    }
  },
};
</script>
<style scoped lang="scss">
$border: 1px solid #cdcdcd;

.print-vertical-card {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 12px;
  font-size: 12px;
  table-layout: fixed;

  &__label-col {
    width: 110px;
  }

  th, td {
    border: 1px solid #aaa;
    padding: 5px 8px;
    vertical-align: top;
  }

  th {
    background-color: #f0f0f0;
    font-weight: 600;
    white-space: nowrap;
  }
}
.label-text {
  width: 114px;
  font-weight: 700;
  font-size: 14px;
}

.custom-checkbox::v-deep {
  .vs-checkbox {
    margin: 0 !important;
  }
}

table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  thead {
    background: #f9f9f9;
    z-index: 0 !important;

    th {
      font-style: normal;
      font-weight: 700;
      font-size: 14px;
      line-height: 18px;
      color: #3c3c3c;

      border-top: solid 1px #cdcdcd;
      border-bottom: solid 1px #cdcdcd;
      padding: 16px 0;
    }
  }

  tbody {
    tr {
      background: #fff !important;
      border-bottom: solid 1px #cdcdcd;

      td {
        padding: 6px;
      }
    }
  }
}

table.label-table {
  @media (min-width: theme("screens.xl")) {
    &,
    tr,
    th,
    td {
      border: 1px solid #cdcdcd;
    }
    td {
      padding: 4px !important;

      &:first-child {
        background: #f9f9f9;
      }
    }
  }
}

table.border-x {
  border-left: $border;
  border-top: $border;

  thead {
    th {
      border-right: $border;
    }
  }

  tbody {
    tr {
      td {
        border-right: $border;
      }
    }
  }
}

.signatureImg {
  border: 1px solid #00000033;
  border-radius: 6px;
  min-height: 80px;
  max-width: 120px;
}

div::v-deep .input-span-placeholder {
  text-align: left;
}

div::v-deep .input-select::placeholder,
div::v-deep textarea::placeholder {
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.4);
  font-weight: 300;
}

.afterTextContainer {
  display: flex;
  align-items: center;
  justify-content: space-between;

  & > * {
    flex: 1;
  }

  .afterText {
    flex: 0;
    padding: 0 7px 0 10px;
  }
}

.errorMsg {
  display: flex;
  align-items: flex-start;

  font-weight: 400;
  font-size: 12px;
  line-height: 17px;
  text-align: left;
  color: #ea5455;
  margin-top: 1px;

  &.err-counter {
    margin-top: 14px;
  }
}

.info {
  position: relative;

  .info-icon {
    cursor: pointer;
  }

  .info-icon:hover + div {
    display: block;
  }

  div {
    display: none;

    position: absolute;
    top: 30px;
    left: -122px;

    width: 225px;

    color: white;
    font-size: 14px;
    font-weight: 500;
    line-height: 20.27px;

    background: #3e3e3e;
    padding: 10px;
    border-radius: 4px;
    z-index: 100;

    &::before {
      content: "";

      position: absolute;
      left: 122px;
      top: -8px;

      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0px 8px 8px 8px;
      border-color: transparent transparent #3e3e3e transparent;
    }
  }
}

.btn {
  cursor: pointer;
  border-radius: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #6670cb;

  &:hover {
    background: #6670cb;
    color: #ffffff;
  }

  &.disabled {
    cursor: not-allowed;
    background: #f9f9f9;
    color: #cdcdcd;
    border: 1px solid #cdcdcd;

    &:hover {
      background: #f9f9f9;
      color: #cdcdcd;
    }
  }
}

.addGroupButton {
  cursor: pointer;

  &.disabled {
    cursor: not-allowed;
    background: #f9f9f9;
    color: #cdcdcd;
    border: 1px solid #cdcdcd;

    &:hover {
      background: #f9f9f9;
      color: #cdcdcd;
    }
  }
}

.order-by {
  display: none;
}
.tbody-tr:hover {
  .order-by {
    display: block;
  }
}
</style>
